import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';
import { useAuth } from '../../authContext.js';
import { useImpersonatedUserStorage } from '../useImpersonatedUserStorage.js';
import { useSelectedCompanyStorage } from '../useSelectedCompanyStorage.js';
// Impersonates the given user, or ends the impersonation without one. Impersonating a user drops the selected company,
// in the storage too, so no tab restores both.
export const useImpersonateUser = () => {
    const { forgetImpersonatedUser, storeImpersonatedUser } = useImpersonatedUserStorage();
    const { forgetSelectedCompany } = useSelectedCompanyStorage();
    const { setImpersonatedUser, setSelectedCompany } = useAuth();
    return useCallbackRef((user) => {
        if (user) {
            forgetSelectedCompany();
            setSelectedCompany(null);
            storeImpersonatedUser(user);
        }
        else {
            forgetImpersonatedUser();
        }
        setImpersonatedUser(user);
    });
};
